import styled from 'styled-components';

import { mediaWide } from '@xing-com/layout-tokens';

export const CompassWrapper = styled.div`
  flex-basis: 100%;

  @media ${mediaWide} {
    flex-basis: 60%;
  }
`;
